export default [
  '10',
  '20',
  '50',
  '100'
]